import { Injectable } from '@angular/core';
import { NbRoleProvider } from '@nebular/security';
import { Observable, of } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';

/**
 * Provides user role determination, authentication agnostic
 */
@Injectable()
export class RoleProvider implements NbRoleProvider {
  constructor(private authService: AuthService) {}

  getRole(): Observable<string[]> {
    const roles = this.authService.getUser().role;
    if (roles) {
      return of(roles);
    } else {
      return of(['']);
    }
  }
}
